import { create } from 'zustand';
import { api } from '@/shared/api/client';

export type Recent = { id: string; entity_type: string; entity_id: string; label: string; viewed_at: string };
type TrackEntry = { entity_type: string; entity_id: string; label: string };

type State = {
  recents: Recent[];
  hydrated: boolean;
  hydrate: () => Promise<void>;
  track: (e: TrackEntry) => Promise<void>;
  reset: () => void;
};

const dedupe = (list: Recent[], t: { entity_type: string; entity_id: string }) =>
  list.filter((r) => !(r.entity_type === t.entity_type && r.entity_id === t.entity_id));

export const useRecentsStore = create<State>((set) => ({
  recents: [],
  hydrated: false,
  hydrate: async () => {
    try { const data = await api.get<Recent[]>('/recents'); set({ recents: data, hydrated: true }); }
    catch { set({ hydrated: true }); }
  },
  track: async (e) => {
    set((s) => ({ recents: [{ id: `tmp-${e.entity_type}-${e.entity_id}`, ...e, viewed_at: '' }, ...dedupe(s.recents, e)].slice(0, 50) }));
    try {
      const row = await api.post<Recent>('/recents', e);
      set((s) => ({ recents: [row, ...dedupe(s.recents, row)].slice(0, 50) }));
    } catch { /* next hydrate corrects */ }
  },
  reset: () => set({ recents: [], hydrated: false }),
}));
